import Request from './request'

const ClientInvoice  = {
  getInvoiceList(params, callback) {
    Request.get('client-invoices', params).then(callback).catch(this.bad_answer)
  },
  getInvoice(id, callback) {
    Request.get('client-invoices/' + id).then(callback).catch(this.bad_answer)
  },
  getCurrencyRate(params, callback) {
    Request.get('client-invoices/currency-rate', params).then(callback).catch(this.bad_answer)
  },
  updateInvoiceValidationStatus(id, params, callback) {
    Request.put('client-invoices/' + id + '/status', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateInvoice(id, params, callback) {
    Request.put('client-invoices/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateInvoiceDetails(id, params, callback) {
    Request.put('client-invoices/update-device-detail/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  putSetIssued(id, params, callback) {
    Request.put('client-invoices/' + id + '/set-issued', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  downloadDetails(id, callback){
    Request.get('client-invoices/download/' + id, null, { responseType: 'blob' }).then(callback).catch(this.bad_answer)
  }
}

export default ClientInvoice
